<template>
    <v-container fluid pa-0 mt-1>
        <v-card
                class="mx-auto"
                outlined
                elevation="10"
                id="app-image-gallery">

            <v-row>
                <v-col><h3>{{$t('images.imageGalleryTitle') }} </h3></v-col>
            </v-row>

            <v-row v-if="images.length === 0">
                <v-col>{{$t('images.noImages') }}</v-col>
            </v-row>

            <v-row>
                    <v-card flat class="d-flex" id="app-image-card"
                            v-for="(image, i) in images"
                            :key="image.url">
                        <v-img
                                :src="image.url"
                                :lazy-src="image.url"
                                :alt="image.alt"
                                :title="image.alt"
                                aspect-ratio="1"
                                class="grey"
                                @click="openCarousel(i)"
                                id="app-image"
                        >
                            <template v-slot:placeholder>
                                <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                >
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-row>
                            </template>
                        </v-img>
                    </v-card>
            </v-row>

            <v-dialog width="fit-content"
                      v-model="showCarousel"
                      @keydown.right="navigate('right', images.length-1)"
                      @keydown.left="navigate('left', images.length-1)">
                <v-carousel id="app-carousel"
                            width="fit-content"
                            height="fit-content"
                            v-model="index"
                            :show-arrows="images.length > 1"
                            hide-delimiters>

                    <v-carousel-item
                            v-for="(image, i) in images"
                            :key="i"
                            class="app-carousel-item"

                    >


                        <img :src="image.url" :alt="image.alt"
                            style="max-width: 100%">

                        <div class="app-image-caption">
                            {{ image.title }}
                        </div>

                    </v-carousel-item>
                </v-carousel>
            </v-dialog>


        </v-card>
    </v-container>

</template>

<script>
    import axios from 'axios'
    import {speciesUrl} from '../../data/app-data'
    import {API_ERROR_MESSAGE} from '../../data/constants'

    export default {
        name: 'ImageGallery',
        data() {
            return {
                images: [],
                index: null,
                showCarousel: false,
            }
        },
        computed: {
            taxonId() {
                return this.$store.state.taxonId
            },
            taxonName() {
                return this.$store.state.taxonName
            }
        },
        watch: {
            taxonId: {
                handler () {
                    this.getImages()
                },
                immediate: true
            },
            showCarousel() {
                // customize keyboard event handling in opened v-dialog for image gallery
                const handler = e => {
                    if (e.keyCode === 27) {
                        this.showCarousel = false
                        window.removeEventListener('keydown', handler)
                    } else if (e.keyCode  === 37) {
                        this.navigate('left', this.images.length -1)
                    } else if  (e.keyCode  === 39) {
                        this.navigate('right', this.images.length -1)
                    }
                }
                if (this.showCarousel) {
                    window.addEventListener('keydown', handler)
                } else {
                    window.removeEventListener('keydown', handler)

                }
            }

        },
        methods: {
            openCarousel(i) {
                this.index = i
                this.showCarousel = true
            },

            navigate(direction, maxIndex) {
                // check for left and right arrow keydown events to control the v-carousel component using the keyboard
              if (direction === 'left') {
                  this.index === 0 ? this.index = maxIndex : this.index--
              }  else if (direction === 'right') {
                  this.index === maxIndex ? this.index = 0 : this.index++
              }
            },

            fixUrl(path, filename) {
                // fix file names with erroneous namings from database
                let hasFileExtension = filename.lastIndexOf('.') >= 0
                let sanitizedFilename = hasFileExtension ?
                    filename.substr(0, filename.lastIndexOf('.')) :
                    filename

                return filename.split('.').pop() === 'jpeg' ? encodeURI(`${path}${filename}`) : encodeURI(`${path}${sanitizedFilename}.jpg`)
            },
            getImages() {
                this.images = []

                axios.get(speciesUrl.speciesImages + this.taxonId).then((result) => {
                    result.data.forEach(image => {
                        let imageText = image.imageText ? ' (' + image.imageText + ')' : ''

                        let result = {
                            url: this.fixUrl(image.imagePath, image.imageFilename),
                            alt: this.$store.state.currentName + imageText + ', \u00A9' + image.imageCopyright.replace('&#169;', '') + ' (' + image.imageFilename + ' )' ,
                            title: this.$store.state.currentName + imageText + ', \u00A9' + image.imageCopyright.replace('&#169;', '')
                        }

                        this.images.push(result)
                    })
                }).catch((error) => {
                    console.log(API_ERROR_MESSAGE, error)
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../global';

    h3 {
        color: $app-light-yellow;
    }

    #app-image {
        width: 100px;
        height: 100px;
        background-size: contain;
        cursor: pointer;
        border-radius: 5px;
    }

    #app-image-card {
        background-color: $app-black;
        max-width: 100px;
        margin: 10px
    }

    #app-image-gallery {
        background-color: $app-black;
        color: $app-light-yellow;
        padding: 15px 25px 15px 25px;
        margin-bottom: 40px;
        margin-top: 50px;
    }

    .app-image-caption {
        opacity: 1;
        display: block;
        width: 100%;
        background-color: black;
        color: white;
        border-radius: 5px;
        padding: 3px 3px 10px 3px;
        text-align: center;
        font-size: small;
    }

    .app-carousel-item {
        background-color: black;
        text-align: center;
    }

    #app-carousel {
        border: 2px solid $app-light-antique;
    }

</style>